export default {
      id: "arrows-usage",
      viewBox: "0 0 18 14",
      url: __webpack_public_path__ + "sprite.1792148661250.svg#arrows-usage",
      toString: function () {
        return this.url;
      }
    }